/*eslint-disable*/
import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from 'react-i18next'

// helpers
import { getFullName, getLastLogin } from "../../../../helpers/users";
import Breadcrumbs from "../../../../components/Breadcrumbs";

const PageHeader = ({ user }) => {
  const { t } = useTranslation()

  return (
    <Box
      style={{ backgroundColor: "#f5f5f5", width: "100vw", padding: "20px" }}
    >
      <Breadcrumbs value={"Users / View & Edit"} extraLinks={[{ label: getFullName(user), link: "" }]} />
      <h1 style={{ paddingLeft: "80px", marginTop: "15px", marginBottom: "8px" }}>
        {getFullName(user)}
      </h1>
      <p style={{ paddingLeft: "80px", marginTop: "0px", marginBottom: "18px", fontSize: "14px", color: "#564C47" }}>
        {t('view-user-last-login')}
        {getLastLogin(user)}
      </p>
    </Box>
  );
};

export default PageHeader;
